import React, { useEffect, useCallback } from 'react';
import { noop } from '../../utils/helper';

function PostDispatchCancellationMessage(props) {
  const {
    userInfo: { telephone } = {},
    view = 'mobile',
    clickHandler = noop,
    dataLocale: {
      ITEM_ALREADY_SHIPPED,
      ORDER_CANNOT_CANCELLED,
      KNOW_MORE,
      ORDER_CANCELLATION,
      ORDER_NOT_CANCELLEABLE,
    },
  } = props;
  const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
  const mobile = btoa(telephone);
  useEffect(() => {
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.postDispatchCancelClick({
        ctaname: 'order cant be cancel msg appeared',
        mobile,
      });
    }
  }, []);
  const clickHandlerFn = useCallback(() => {
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.postDispatchCancelClick({
        ctaname: 'order cant be cancelled|know more',
        mobile,
      });
    }
    clickHandler();
  }, []);
  return (
    <div
      className={`bg-color_ee bora-8${view === 'desktop' ? ' padding-20 margin-t15' : ' pd-16'}`}
    >
      <div className="display-flex justify-space-between align-items-center">
        <div>
          <span className="fw700">
            {view === 'desktop' ? ORDER_CANCELLATION : ORDER_CANNOT_CANCELLED}
          </span>
          {view === 'desktop' && <span>: </span>}
          <span className={`${view !== 'desktop' ? 'block' : ''}`}>
            {view === 'desktop' ? ORDER_NOT_CANCELLEABLE : ITEM_ALREADY_SHIPPED}
          </span>
        </div>
        <div
          className={`fw700 text-uppercase${
            view === 'desktop' ? ' cursor-pointer text-color-primary' : ' text-color_link_blue'
          }`}
          onClick={clickHandlerFn}
        >
          {KNOW_MORE}
        </div>
      </div>
    </div>
  );
}

export default PostDispatchCancellationMessage;
